<template>
  <Dialog :title="$t('Cambio de centro')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <v-stepper v-model="active_step">
        <v-stepper-header>
          <v-stepper-step :complete="active_step > 1" step="1">{{ $t("Seleccione el centro") }}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="active_step > 2" step="2">{{ $t("Seleccione el empleado") }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">{{ $t("Confirme el inicio de sesión") }}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!--Tabla de selección de centros-->
          <v-stepper-content step="1">
            <TablaCentros
                @on_item_select="seleccionar_centro"
            />
          </v-stepper-content>

          <!--Tabla de selección de empleado-->
          <v-stepper-content step="2">
            <TablaEmpleadosCentro
                v-if="centro"
                :centro="centro"
                @on_item_select="seleccionar_user"
            />
          </v-stepper-content>

          <!--Form de login-->
          <v-stepper-content step="3">
            <div v-if="centro && empleado">
              <v-row>
                <v-col cols="12"><h3>{{$t('Datos del centro')}}</h3></v-col>
                <v-col cols="6">
                  <v-text-field
                      :label="$t('Nombre')"
                      type="text"
                      disabled
                      class="force-black"
                      v-model="centro.nombre"
                      outlined
                      dense
                      readonly
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      :label="$t('Dirección')"
                      type="text"
                      disabled
                      class="force-black"
                      v-model="centro.direccion"
                      outlined
                      dense
                      readonly
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"><h3>{{$t('Datos del empleado')}}</h3></v-col>
                <v-col cols="6">
                  <v-text-field
                      :label="$t('Nombre')"
                      type="text"
                      disabled
                      class="force-black"
                      v-model="empleado.first_name"
                      outlined
                      dense
                      readonly
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      :label="$t('Email')"
                      type="text"
                      disabled
                      class="force-black"
                      v-model="empleado.email"
                      outlined
                      dense
                      readonly
                  />
                </v-col>
              </v-row>
              <v-btn v-if="empleado" block @click="cambiar_empleado" class="primary ml-2">{{ $t("Iniciar sesión") }}</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
    <template v-slot:right-action>
      <v-btn v-if="active_step>=2" small @click="active_step>=2?active_step-=1:active_step=1" class="primary ml-2">{{ $t("Volver") }}</v-btn>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "DialogCambiarUsuario",
  props: ['value'],
  data(){
    return {
      active_step: 1,
      centro: null,
      empleado: null,
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  methods:{
    async seleccionar_centro(item){
      this.centro=item
      this.empleado=null
      this.active_step=2
    },
    async seleccionar_user(item){
      this.empleado=item
      this.active_step=3
    },
    async cambiar_empleado(){
      const token = await this.$store.dispatch('auth/get_token_autologin', this.empleado.id)
      await this.$router.replace({name: 'autologin', query: {token}})
    }
  },
  components: {
    TablaCentros: () => import('./TablaCentros'),
    TablaEmpleadosCentro: () => import('./TablaEmpleadosCentro'),
  }
}
</script>

<style scoped>

.force-black >>> input {
  color: black !important;
}

</style>
